import { hydrateRoot } from "react-dom/client";
import { StartClient } from "@tanstack/react-start";
import { createRouter } from "./router";
import * as Sentry from "@sentry/tanstackstart-react";

const router = createRouter();

Sentry.init({
  dsn: "https://2761ae183c669e63682a8a22e70f6cad@o4508840544698368.ingest.de.sentry.io/4508840550727760",

  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/tanstackstart-react/configuration/options/#sendDefaultPii
  sendDefaultPii: true,

  integrations: [
    Sentry.tanstackRouterBrowserTracingIntegration(router),
    Sentry.captureConsoleIntegration({
      levels: ["error"],
    }),
  ],
  // Enable logs to be sent to Sentry
  _experiments: { enableLogs: true },
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  // We recommend adjusting this value in production.
  // Learn more at https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
  tracesSampleRate: 1.0,
});

hydrateRoot(document, <StartClient router={router} />);
